import { render, staticRenderFns } from "./HomeDesktopVersion.vue?vue&type=template&id=68dc95b2&"
import script from "./HomeDesktopVersion.vue?vue&type=script&lang=js&"
export * from "./HomeDesktopVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports